module.exports = __webpack_public_path__ + "img/img001.0eda8360.png";